import './assets/css/variables.css';

import './utils/class-component-hooks';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'popper.js';
import 'jquery';
import 'bootstrap';
import {i18n} from '@/i18n';
import VueWindowSize from 'vue-window-size';
import DeviceType from './utils/DeviceUtil';
import {format} from './utils/Helpers';

Vue.config.productionTip = false;
Vue.use(VueWindowSize);
Vue.mixin(DeviceType);

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
import {
    AxiosResponse,
}
    from 'axios';

Vue.use(VueToast, {
    position: 'top-right',
    duration: 5000,
});

import moment from 'moment';
import api from '@/network/api';
const currentLocation = window.location.href;
const urlParts = currentLocation.split("/");
if ( urlParts.length > 0 ) {
    const protocol = urlParts[0];
    let domain = urlParts[1];
    if (domain === '') {
        domain = urlParts[2];
    }

    if (domain.includes(':')){
        const domainParts = domain.split(':');
        domain = domainParts[0]
    };
    const notificationServerUrl = `${protocol}//${domain}:8810`;
    // const socket = io(notificationServerUrl);
    // Vue.use(VueSocketIOExt, socket);
}

Vue.filter('truncate', (text: string, shouldTruncate: boolean, length: number) => {
    if (shouldTruncate) {
        if (text.length > length) {
            return text.substr(0, length) + '...';
        } else {
            return text;
        }
    } else {
        return text;
    }
});
Vue.filter('isoToShortTime', (time: string) => {
    const localTime = moment(time, 'HH:mm').utc(true).local();
    const amPm = localTime.format('A');
    return `${localTime.format('hh:mm')} ${i18n.t(amPm)}`;
});

Vue.filter('isoToShortTimeOnly', (time: string) => {
    const localTime = moment(time, 'HH:mm').utc(true).local();
    return `${localTime.format('hh:mm')}`;
});

Vue.filter('isoToShortHourClock', (time: string) => {
    const localTime = moment(time, 'HH:mm').utc(true).local();
    const amPm = localTime.format('A');
    return `${i18n.t(amPm)}`;
});

Vue.filter('isoToShortDateTime', (time: string) => {
    const localDateTime = moment.utc(time).local()
    const amPm = localDateTime.format('A');
    return `${localDateTime.format('D/M/Y hh:mm')} ${i18n.t(amPm)}`;
});

Vue.filter('shortTime', (time: string) => {
    if (time) {
        const amPm = moment(time, 'HH:mm:ss').format('A');
        return moment(time, 'HH:mm:ss').format('hh:mm') + ' ' + i18n.t(amPm);
    }
});

Vue.filter('asLocalDate', (date: string) => {
    if (date) {
        return date.replace(/-/g, '/');
    }
});

Vue.filter('duration', (session: any) => {
    const fromDate = new Date(`${session.date} ${session.from}`);
    const toDate = new Date(`${session.date} ${session.to}`);
    const duration = (toDate.getHours() * 60 + toDate.getMinutes()) - (fromDate.getHours() * 60 + fromDate.getMinutes());

    return duration.toString() ;
});

function convertDateForIos(date: any) {
    const arr = date.split(/[- :]/);
    date = new Date(arr[0], arr[1]-1, arr[2], arr[3], arr[4], arr[5]);
    return date;
}


Vue.filter('durationWithTimeTag', (session: any) => {
    const fromDate = convertDateForIos(`${session.date} ${session.from}`);
    const toDate = convertDateForIos(`${session.date} ${session.to}`);
    const duration = (toDate.getHours() * 60 + toDate.getMinutes()) - (fromDate.getHours() * 60 + fromDate.getMinutes());
    if(duration >= 60 ) {
        const hours =((duration-(duration%60))/60).toFixed(0).toString();
        const minuts= (duration%60).toFixed(0).toString();
        if(minuts == "0") {
        return hours+i18n.t("h");
        }
        return hours+":"+minuts+i18n.t("h");
    }
    return duration.toString() + i18n.t("m");
});

Vue.filter('dayOfWeek', (date: string) => {
    if (date) {
        const day = (new Date(date)).getDay();
        switch (day) {
            case 0:
                return i18n.t('Sunday');
            case 1:
                return i18n.t('Monday');
            case 2:
                return i18n.t('Tuesday');
            case 3:
                return i18n.t('Wednesday');
            case 4:
                return i18n.t('Thursday');
            case 5:
                return i18n.t('Friday');
            case 6:
                return i18n.t('Saturday');
        }
    }

    return '';
});

Vue.filter('countdown', (seconds: number) => {
    if (seconds > 0) {
        const remainderSeconds = seconds % 60;
        seconds = Math.floor(seconds / 60);

        const remainersMinutes = seconds % 60;
        seconds = Math.floor(seconds / 60);

        const remainderHours = seconds;

        if (remainderHours > 0) {
            return format(remainderHours) + ':' + format(remainersMinutes) + ':' + format(remainderSeconds);
        } else if (remainersMinutes > 0) {
            return format(remainersMinutes) + ':' + format(remainderSeconds);
        } else {
            return format(remainderSeconds);
        }
    } else {
        return '';
    }
});

Vue.filter('unread', (notifications: any) => {
    if (Array.isArray(notifications) && notifications.length > 0) {
        return notifications.filter((item: any) => {
            if (!item.is_read) {
                return item;
            }
        }).length;
    } else {
        return 0;
    }
});

import loading from 'vuejs-loading-screen';
import {fullScreenOnLandscapeDirective} from '@/pages/directives/full-screen-on-landscape-directive';

Vue.use(loading, {
    bg: '#ffffff00',
    icon: 'spinner',
    size: 3,
    // eslint-disable-next-line @typescript-eslint/camelcase
    'icon_color': 'rgb(19, 89, 100)',
})

Vue.prototype.$http = api;
api.interceptors.request.use(
    config => {
        if (config.url !== 'notifications') {
            Vue.prototype.$isLoading(true);
        }
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers = Object.assign({
                Authorization: `Bearer ${token}`,
            }, config.headers)
        }
        return config;
    },
    error => {
        Vue.prototype.$isLoading(false);
        return Promise.reject(error);
    },
);

api.interceptors.response.use(
    response => {
        Vue.prototype.$isLoading(false);
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response);
        } else {
            Vue.prototype.$isLoading(false);
            return Promise.reject(response);
        }
    },
    error => {
        if (error.response.status === 401) { // only Unauthenticated should force logout
            store.dispatch("logout")
        }

        Vue.prototype.$isLoading(false);

        return Promise.reject(error.response);
    },
);

// VueCryptojs
import VueCryptojs from 'vue-cryptojs';
Vue.use(VueCryptojs);

// directives
Vue.directive('fullScreenOnLandscape', fullScreenOnLandscapeDirective);
new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
}).$mount('#app')
